(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumen-chart"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('.lumen-chart-wrap:not([data-lc-init])');
    roots.forEach(function(root){
      root.setAttribute('data-lc-init','1');

      var data = {
        pgm1h: { color:'#28c8e6', label:'PGM 1 - H', points:[
          [5,50],[6,90],[7,160],[8,230],[9,310],[10,380],[11,450],[12,520],[13,580],[14,640],
          [15,700],[16,740],[17,770],[18,800],[19,820],[20,840],[22,880],[24,920],[26,970],
          [28,1040],[30,1100],[32,1110],[35,1100]
        ]},
        pgm1l: { color:'#1a5cff', label:'PGM 1 - L', points:[
          [5,150],[6,210],[7,260],[8,295],[9,315],[10,320],[12,310],[15,305],[20,302],[25,300],[30,300],[35,300]
        ]},
        pgm2h: { color:'#ff2a2a', label:'PGM 2 - H', points:[
          [5,1600],[8,1660],[10,1690],[13,1735],[15,1760],[18,1795],[20,1815],
          [23,1845],[25,1865],[28,1900],[30,1925],[32,1965],[35,2000]
        ]},
        pgm2l: { color:'#f29400', label:'PGM 2 - L', points:[
          [5,1150],[8,1185],[10,1210],[13,1235],[15,1255],[18,1275],[20,1290],
          [23,1310],[25,1325],[28,1355],[30,1385],[32,1430],[35,1500]
        ]}
      };

      var W=1200, H=720, P={left:100,right:60,top:60,bottom:100};
      var xMin=0,xMax=40,yMin=0,yMax=2000;
      var xTicks=[0,5,10,15,20,25,30,35,40];
      var yTicks=[0,200,400,600,800,1000,1200,1400,1600,1800,2000];
      function xs(v){return P.left+(v-xMin)/(xMax-xMin)*(W-P.left-P.right);}
      function ys(v){return (H-P.bottom)-(v-yMin)/(yMax-yMin)*(H-P.top-P.bottom);}
      var NS='http://www.w3.org/2000/svg';

      var svg     = root.querySelector('.lumen-chart-svg');
      var gridG   = root.querySelector('.lc-grid');
      var linesG  = root.querySelector('.lc-lines');
      var capture = root.querySelector('.lc-capture');
      var hLine   = root.querySelector('.lc-hover-line');
      var hDots   = root.querySelector('.lc-hover-dots');
      var hTip    = root.querySelector('.lc-hover-tip');
      var tSpeed  = root.querySelector('.lc-tip-speed');
      var tRows   = root.querySelector('.lc-tip-rows');

      function mkLine(x1,y1,x2,y2,cls){var l=document.createElementNS(NS,'line');l.setAttribute('class',cls);l.setAttribute('x1',x1);l.setAttribute('y1',y1);l.setAttribute('x2',x2);l.setAttribute('y2',y2);return l;}
      gridG.appendChild(mkLine(xs(xMin),ys(yMin),xs(xMax),ys(yMin),'lc-axis'));
      gridG.appendChild(mkLine(xs(xMin),ys(yMin),xs(xMin),ys(yMax),'lc-axis'));

      for(var i=0;i<xTicks.length;i++){
        for(var j=0;j<yTicks.length;j++){
          var d=document.createElementNS(NS,'circle');
          d.setAttribute('class','lc-grid-dot');
          d.setAttribute('cx',xs(xTicks[i]));
          d.setAttribute('cy',ys(yTicks[j]));
          d.setAttribute('r',1.6);
          gridG.appendChild(d);
        }
      }
      xTicks.forEach(function(t){var x=document.createElementNS(NS,'text');x.setAttribute('class','lc-tick-text');x.setAttribute('x',xs(t));x.setAttribute('y',ys(0)+28);x.setAttribute('text-anchor','middle');x.textContent=t;gridG.appendChild(x);});
      yTicks.forEach(function(t){var y=document.createElementNS(NS,'text');y.setAttribute('class','lc-tick-text');y.setAttribute('x',xs(0)-14);y.setAttribute('y',ys(t)+5);y.setAttribute('text-anchor','end');y.textContent=t;gridG.appendChild(y);});

      function smooth(pts){
        if(!pts.length)return '';
        var d='M '+pts[0][0]+' '+pts[0][1];
        for(var i=0;i<pts.length-1;i++){
          var p0=pts[i-1]||pts[i],p1=pts[i],p2=pts[i+1],p3=pts[i+2]||p2;
          d+=' C '+(p1[0]+(p2[0]-p0[0])/6)+' '+(p1[1]+(p2[1]-p0[1])/6)+' '+(p2[0]-(p3[0]-p1[0])/6)+' '+(p2[1]-(p3[1]-p1[1])/6)+' '+p2[0]+' '+p2[1];
        }
        return d;
      }

      var pathEls={};
      Object.keys(data).forEach(function(k){
        var s=data[k];
        var px=s.points.map(function(p){return [xs(p[0]),ys(p[1])];});
        var p=document.createElementNS(NS,'path');
        p.setAttribute('class','lc-line');
        p.setAttribute('d',smooth(px));
        p.setAttribute('stroke',s.color);
        p.style.color=s.color;
        linesG.appendChild(p);
        pathEls[k]=p;
      });

      root.querySelectorAll('.lc-btn').forEach(function(b){
        b.addEventListener('click',function(){
          var k=b.dataset.key;
          var a=b.classList.toggle('is-active');
          pathEls[k].classList.toggle('is-hidden',!a);
        });
      });

      function interp(pts,x){
        if(x<=pts[0][0])return pts[0][1];
        if(x>=pts[pts.length-1][0])return pts[pts.length-1][1];
        for(var i=0;i<pts.length-1;i++){
          var a=pts[i],b=pts[i+1];
          if(x>=a[0]&&x<=b[0]){var t=(x-a[0])/(b[0]-a[0]);return a[1]+t*(b[1]-a[1]);}
        }
        return null;
      }
      function pt(e){var p=svg.createSVGPoint();p.x=e.clientX;p.y=e.clientY;var c=svg.getScreenCTM();return c?p.matrixTransform(c.inverse()):{x:0,y:0};}

      function show(e){
        var p=pt(e);
        var px=Math.max(P.left,Math.min(W-P.right,p.x));
        var sp=(px-P.left)/(W-P.left-P.right)*(xMax-xMin)+xMin;
        if(sp<5)sp=5;if(sp>35)sp=35;
        var sx=xs(sp);
        hLine.setAttribute('x1',sx);hLine.setAttribute('x2',sx);
        hLine.setAttribute('y1',P.top);hLine.setAttribute('y2',H-P.bottom);
        hLine.setAttribute('opacity','0.6');
        while(hDots.firstChild)hDots.removeChild(hDots.firstChild);
        while(tRows.firstChild)tRows.removeChild(tRows.firstChild);
        tSpeed.textContent=Math.round(sp)+' mph';
        var ry=44, vc=0;
        Object.keys(data).forEach(function(k){
          var b=root.querySelector('.lc-btn[data-key="'+k+'"]');
          if(!b.classList.contains('is-active'))return;
          var s=data[k], lm=interp(s.points,sp);
          if(lm==null)return;
          vc++;
          var dot=document.createElementNS(NS,'circle');
          dot.setAttribute('cx',sx);dot.setAttribute('cy',ys(lm));dot.setAttribute('r',5);
          dot.setAttribute('fill',s.color);dot.setAttribute('stroke','#000');dot.setAttribute('stroke-width',1.5);
          hDots.appendChild(dot);
          var d2=document.createElementNS(NS,'circle');
          d2.setAttribute('cx',18);d2.setAttribute('cy',ry-4);d2.setAttribute('r',4);d2.setAttribute('fill',s.color);
          tRows.appendChild(d2);
          var lb=document.createElementNS(NS,'text');
          lb.setAttribute('class','lc-tip-row-label');lb.setAttribute('x',30);lb.setAttribute('y',ry);
          lb.textContent=s.label; tRows.appendChild(lb);
          var vl=document.createElementNS(NS,'text');
          vl.setAttribute('class','lc-tip-row-value');vl.setAttribute('x',158);vl.setAttribute('y',ry);vl.setAttribute('text-anchor','end');
          vl.textContent=Math.round(lm)+' lm'; tRows.appendChild(vl);
          ry+=18;
        });
        if(vc===0){hTip.setAttribute('opacity','0');return;}
        var tw=170, th=28+vc*18;
        hTip.querySelector('rect').setAttribute('height',th);
        var tx=sx+14;
        if(tx+tw>W-P.right) tx=sx-tw-14;
        hTip.setAttribute('transform','translate('+tx+','+(P.top+10)+')');
        hTip.setAttribute('opacity','1');
      }
      function hide(){
        hLine.setAttribute('opacity','0');
        hTip.setAttribute('opacity','0');
        while(hDots.firstChild)hDots.removeChild(hDots.firstChild);
      }

      capture.addEventListener('mousemove',show);
      capture.addEventListener('mouseleave',hide);
      capture.addEventListener('touchmove',function(e){if(e.touches[0])show(e.touches[0]);},{passive:true});
      capture.addEventListener('touchend',hide);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
